import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { DownloadTypeViewData } from '../types';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';
import { GzDropdownWebComponent } from '../../../../../ui/gzDropdown';
import { translateFn } from '../../../../../utils/translator.helper';
import { TemplateState } from '../../../../../types/common/types';
import { RequiredValidator } from '../../../../../ui/gzForm/validators/required.validator';
import { GzTitleWebComponent } from '../../../../../ui/gzTitle';
import { FormGroup } from '../../../../../ui/gzForm/formGroup/form-group';
import { KitDataSummary } from '../../../../../packages/downloadKitButtonSelector/constants';

export class DownloadTypeFormView extends BaseWebComponentView {
  public formGroup!: FormGroup;

  public dom: {
    $wrapper: HTMLElement;
    $detailsSubtitle: GzTitleWebComponent;
    $downloadTypeFormField: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $downloadTypeFormField: this.shadow.querySelector('#download-type-form-field'),
      $detailsSubtitle: this.shadow.querySelector('#details-subtitle'),
    };
    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
  }

  setTranslatedStrings() {
    this.dom.$detailsSubtitle.innerText = translateFn('Details');
    this.dom.$downloadTypeFormField.label = translateFn('Download type');
    this.dom.$downloadTypeFormField.Input.placeholder = translateFn('Choose download type');
    this.dom.$downloadTypeFormField.Input.noResultsFound = this.commonStrings.noResultsFound;
  }

  buildSuccessView(data: DownloadTypeViewData) {
    this.setDropdownOptions(data.kitData);
    this.createFormGroup();
  }

  buildErrorView(error: Error) {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }

  private createFormGroup(): void {
    this.setValidators();

    this.formGroup = FormGroup.build({
      downloadType: this.dom.$downloadTypeFormField,
    });
  }

  private setValidators(): void {
    this.dom.$downloadTypeFormField.Validators = [RequiredValidator(this.commonStrings.requiredField)];
  }

  private setDropdownOptions(kitsData: KitDataSummary[]): void {
    this.dom.$downloadTypeFormField.Input.options = kitsData.map((kitData: KitDataSummary) => {
      return {
        title: kitData.value,
        value: kitData.type,
      };
    });
  }
}
